// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useParams, useNavigate, Link } from "react-router-dom";
// import { Card, Row, Col, Modal, Badge } from "react-bootstrap";
// import Swal from "sweetalert2";
// import { BASE_URL } from "../../services/Api";
// import { authHeader } from "../../services/auth-header";
// import {
//   IoBusiness,
//   IoPerson,
//   IoCall,
//   IoMail,
//   IoDocument,
//   IoLocation,
//   IoBank,
//   IoCalendar,
//   IoDownload,
//   IoEye,
//   IoPencil
// } from "react-icons/io5";
// import { FaFilePdf, FaFileImage } from "react-icons/fa";

// const CompanyView = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [companyData, setCompanyData] = useState(null);
//   const [fetchedImages, setFetchedImages] = useState([]);
//   const [showModel, setShowModel] = useState(false);
//   const [currentDoc, setCurrentDoc] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchCompanyData = async () => {
//       try {
//         setLoading(true);
//         const response = await axios.get(`${BASE_URL}company/findById/${1}`, {
//           headers: authHeader(),
//         });

//         const Data = response.data;
//         setCompanyData(Data);

//         // Fetch images
//         if (Data.companyImages && Data.companyImages.length > 0) {
//           const imagePromises = Data.companyImages.map(async (i) => {
//             try {
//               const response = await axios.get(
//                 BASE_URL + `companyImages/findById/${i.id}`,
//                 {
//                   headers: authHeader(),
//                   responseType: "blob",
//                 }
//               );
//               const contentType = response.headers["content-type"];
//               const blob = new Blob([response.data], { type: contentType });
//               const fileUrl = URL.createObjectURL(blob);
//               return {
//                 src: fileUrl,
//                 name: i.filename,
//                 type: i.contenttype,
//                 id: i.id
//               };
//             } catch (error) {
//               console.log("error in image fetch", error);
//               return null;
//             }
//           });

//           const imageUrls = await Promise.all(imagePromises);
//           setFetchedImages(imageUrls.filter(img => img !== null));
//         }
//       } catch (error) {
//         Swal.fire({
//           icon: "error",
//           title: "Error",
//           text: "Failed to fetch company details. Please try again.",
//         });
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCompanyData();
//   }, [id]);

//   const handleCurrentFileView = (doc) => {
//     setCurrentDoc(doc);
//     setShowModel(true);
//   };

//   const handleCloseFileView = () => {
//     setCurrentDoc(null);
//     setShowModel(false);
//   };

//   const handleDownload = () => {
//     if (currentDoc) {
//       const link = document.createElement("a");
//       link.href = currentDoc.src;
//       link.download = currentDoc.name;
//       link.click();
//     }
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     return new Date(dateString).toLocaleDateString('en-IN', {
//       day: '2-digit',
//       month: '2-digit',
//       year: 'numeric'
//     });
//   };

//   const getFileIcon = (fileType) => {
//     if (fileType === "application/pdf") {
//       return <FaFilePdf className="text-danger" size={20} />;
//     }
//     return <FaFileImage className="text-primary" size={20} />;
//   };

//   if (loading) {
//     return (
//       <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
//         <div className="text-center">
//           <div className="spinner-border text-primary" role="status">
//             <span className="visually-hidden">Loading...</span>
//           </div>
//           <p className="mt-2 text-muted">Loading company details...</p>
//         </div>
//       </div>
//     );
//   }

//   if (!companyData) {
//     return (
//       <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
//         <div className="text-center">
//           <h5 className="text-muted">No company data found</h5>
//           <Link to="/company/edit" className="btn btn-primary mt-3">
//             <IoPencil className="me-2" />
//             Add Company Details
//           </Link>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="container-fluid py-4">
//       {/* Header Section */}
//       <div className="d-flex justify-content-between align-items-center mb-4">
//         <div>
//           <h2 className="text-primary mb-1">
//             <IoBusiness className="me-2" />
//             Company Details
//           </h2>
//           <p className="text-muted">View and manage company information</p>
//         </div>
//         <Link to="/company/edit" className="btn btn-primary">
//           <IoPencil className="me-2" />
//           Edit Details
//         </Link>
//       </div>

//       <Row>
//         {/* Basic Information Card */}
//         <Col lg={6} className="mb-4">
//           <Card className="h-100 shadow-sm border-0">
//             <Card.Header className="bg-primary text-white">
//               <h5 className="mb-0">
//                 <IoBusiness className="me-2" />
//                 Basic Information
//               </h5>
//             </Card.Header>
//             <Card.Body>
//               <div className="row g-3">
//                 <div className="col-12">
//                   <label className="form-label text-muted small mb-1">Company Name</label>
//                   <div className="fw-semibold fs-6 text-dark">{companyData.companyname || "N/A"}</div>
//                 </div>

//                 <div className="col-md-6">
//                   <label className="form-label text-muted small mb-1">
//                     <IoPerson className="me-1" />
//                     Contact Person
//                   </label>
//                   <div className="fw-semibold">{companyData.contactperson || "N/A"}</div>
//                 </div>

//                 <div className="col-md-6">
//                   <label className="form-label text-muted small mb-1">
//                     <IoMail className="me-1" />
//                     Email
//                   </label>
//                   <div className="fw-semibold">{companyData.email || "N/A"}</div>
//                 </div>

//                 <div className="col-md-6">
//                   <label className="form-label text-muted small mb-1">
//                     <IoCall className="me-1" />
//                     Work Contact
//                   </label>
//                   <div className="fw-semibold">{companyData.workcontactno || "N/A"}</div>
//                 </div>

//                 <div className="col-md-6">
//                   <label className="form-label text-muted small mb-1">
//                     <IoCall className="me-1" />
//                     Office Contact
//                   </label>
//                   <div className="fw-semibold">{companyData.officecontactno || "N/A"}</div>
//                 </div>
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>

//         {/* Legal & Registration Card */}
//         <Col lg={6} className="mb-4">
//           <Card className="h-100 shadow-sm border-0">
//             <Card.Header className="bg-success text-white">
//               <h5 className="mb-0">
//                 <IoDocument className="me-2" />
//                 Legal & Registration
//               </h5>
//             </Card.Header>
//             <Card.Body>
//               <div className="row g-3">
//                 <div className="col-md-6">
//                   <label className="form-label text-muted small mb-1">PAN Number</label>
//                   <Badge bg="primary" className="fs-6">
//                     {companyData.panno || "N/A"}
//                   </Badge>
//                 </div>

//                 <div className="col-md-6">
//                   <label className="form-label text-muted small mb-1">GST Number</label>
//                   <Badge bg="success" className="fs-6">
//                     {companyData.gstno || "N/A"}
//                   </Badge>
//                 </div>

//                 <div className="col-md-6">
//                   <label className="form-label text-muted small mb-1">CIN Number</label>
//                   <div className="fw-semibold">{companyData.cinno || "N/A"}</div>
//                 </div>

//                 <div className="col-md-6">
//                   <label className="form-label text-muted small mb-1">LUT Number</label>
//                   <div className="fw-semibold">{companyData.lutno || "N/A"}</div>
//                 </div>

//                 <div className="col-md-6">
//                   <label className="form-label text-muted small mb-1">Udyam Registration</label>
//                   <div className="fw-semibold">{companyData.udyamregistrationno || "N/A"}</div>
//                 </div>

//                 <div className="col-md-6">
//                   <label className="form-label text-muted small mb-1">IEC Number</label>
//                   <div className="fw-semibold">{companyData.iecno || "N/A"}</div>
//                 </div>

//                 <div className="col-12">
//                   <label className="form-label text-muted small mb-1">
//                     <IoCalendar className="me-1" />
//                     Incorporation Date
//                   </label>
//                   <div className="fw-semibold">{formatDate(companyData.incorporationdate)}</div>
//                 </div>
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>

//         {/* Bank Details Card */}
//         <Col lg={6} className="mb-4">
//           <Card className="h-100 shadow-sm border-0">
//             <Card.Header className="bg-warning text-dark">
//               <h5 className="mb-0">
//                 {/* <IoBank className="me-2" /> */}
//                 Bank Details
//               </h5>
//             </Card.Header>
//             <Card.Body>
//               <div className="row g-3">
//                 <div className="col-12">
//                   <label className="form-label text-muted small mb-1">Bank Name</label>
//                   <div className="fw-semibold">{companyData.bankname || "N/A"}</div>
//                 </div>

//                 <div className="col-md-6">
//                   <label className="form-label text-muted small mb-1">Account Number</label>
//                   <div className="fw-semibold">{companyData.accountnumber || "N/A"}</div>
//                 </div>

//                 <div className="col-md-6">
//                   <label className="form-label text-muted small mb-1">Branch Name</label>
//                   <div className="fw-semibold">{companyData.branchname || "N/A"}</div>
//                 </div>

//                 <div className="col-12">
//                   <label className="form-label text-muted small mb-1">IFSC Code</label>
//                   <Badge bg="warning" className="fs-6">
//                     {companyData.ifsccode || "N/A"}
//                   </Badge>
//                 </div>
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>

//         {/* Insurance Details Card */}
//         <Col lg={6} className="mb-4">
//           <Card className="h-100 shadow-sm border-0">
//             <Card.Header className="bg-info text-white">
//               <h5 className="mb-0">
//                 <IoDocument className="me-2" />
//                 Insurance Details
//               </h5>
//             </Card.Header>
//             <Card.Body>
//               <div className="row g-3">
//                 <div className="col-md-6">
//                   <label className="form-label text-muted small mb-1">Policy Number</label>
//                   <div className="fw-semibold">{companyData.policynumber || "N/A"}</div>
//                 </div>

//                 <div className="col-md-6">
//                   <label className="form-label text-muted small mb-1">
//                     <IoCalendar className="me-1" />
//                     Valid Till
//                   </label>
//                   <div className="fw-semibold">{formatDate(companyData.policyvalidtill)}</div>
//                 </div>

//                 {companyData.policyvalidtill && new Date(companyData.policyvalidtill) < new Date() && (
//                   <div className="col-12">
//                     <Badge bg="danger" className="fs-6">
//                       Policy Expired
//                     </Badge>
//                   </div>
//                 )}
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>

//         {/* Address Details Card */}
//         <Col lg={12} className="mb-4">
//           <Card className="shadow-sm border-0">
//             <Card.Header className="bg-secondary text-white">
//               <h5 className="mb-0">
//                 <IoLocation className="me-2" />
//                 Company Addresses
//               </h5>
//             </Card.Header>
//             <Card.Body>
//               <Row>
//                 {companyData.companyMultipleAddresses && companyData.companyMultipleAddresses.length > 0 ? (
//                   companyData.companyMultipleAddresses.map((addr, index) => (
//                     <Col md={6} key={index} className="mb-3">
//                       <Card className="h-100 border">
//                         <Card.Header className="bg-light">
//                           <h6 className="mb-0">Address {index + 1}</h6>
//                         </Card.Header>
//                         <Card.Body>
//                           <div className="row g-2">
//                             <div className="col-12">
//                               <label className="form-label text-muted small mb-1">Address</label>
//                               <div className="fw-semibold">{addr.address || "N/A"}</div>
//                             </div>
//                             <div className="col-md-6">
//                               <label className="form-label text-muted small mb-1">City</label>
//                               <div className="fw-semibold">{addr.city?.cityname || "N/A"}</div>
//                             </div>
//                             <div className="col-md-6">
//                               <label className="form-label text-muted small mb-1">State</label>
//                               <div className="fw-semibold">{addr.state?.statename || "N/A"}</div>
//                             </div>
//                             <div className="col-md-6">
//                               <label className="form-label text-muted small mb-1">Country</label>
//                               <div className="fw-semibold">{addr.country?.countryname || "N/A"}</div>
//                             </div>
//                             <div className="col-md-6">
//                               <label className="form-label text-muted small mb-1">Zip Code</label>
//                               <div className="fw-semibold">{addr.zipcode || "N/A"}</div>
//                             </div>
//                             <div className="col-12">
//                               <label className="form-label text-muted small mb-1">State Code</label>
//                               <Badge bg="secondary">{addr.statecode || "N/A"}</Badge>
//                             </div>
//                           </div>
//                         </Card.Body>
//                       </Card>
//                     </Col>
//                   ))
//                 ) : (
//                   <Col>
//                     <div className="text-center text-muted py-4">
//                       <IoLocation size={48} className="mb-2" />
//                       <p>No addresses found</p>
//                     </div>
//                   </Col>
//                 )}
//               </Row>
//             </Card.Body>
//           </Card>
//         </Col>

//         {/* Documents Card */}
//         {fetchedImages.length > 0 && (
//           <Col lg={12} className="mb-4">
//             <Card className="shadow-sm border-0">
//               <Card.Header className="bg-dark text-white">
//                 <h5 className="mb-0">
//                   <IoDocument className="me-2" />
//                   Company Documents
//                 </h5>
//               </Card.Header>
//               <Card.Body>
//                 <Row>
//                   {fetchedImages.map((doc, index) => (
//                     <Col xl={2} lg={3} md={4} sm={6} key={index} className="mb-3">
//                       <Card
//                         className="h-100 document-card"
//                         style={{ cursor: 'pointer' }}
//                         onClick={() => handleCurrentFileView(doc)}
//                       >
//                         <Card.Body className="text-center p-3">
//                           <div className="mb-2">
//                             {getFileIcon(doc.type)}
//                           </div>
//                           <h6 className="document-name small mb-2">
//                             {doc.name.length > 20 ? doc.name.substring(0, 20) + '...' : doc.name}
//                           </h6>
//                           <div className="btn-group btn-group-sm" role="group">
//                             <button
//                               type="button"
//                               className="btn btn-primary"
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 handleCurrentFileView(doc);
//                               }}
//                             >
//                               <IoEye />
//                             </button>
//                             <button
//                               type="button"
//                               className="btn btn-success"
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 const link = document.createElement("a");
//                                 link.href = doc.src;
//                                 link.download = doc.name;
//                                 link.click();
//                               }}
//                             >
//                               <IoDownload />
//                             </button>
//                           </div>
//                         </Card.Body>
//                       </Card>
//                     </Col>
//                   ))}
//                 </Row>
//               </Card.Body>
//             </Card>
//           </Col>
//         )}
//       </Row>

//       {/* Document Preview Modal */}
//       <Modal show={showModel} onHide={handleCloseFileView} size="lg" centered>
//         <Modal.Header closeButton className="bg-dark text-white">
//           <Modal.Title>
//             {getFileIcon(currentDoc?.type)}
//             <span className="ms-2">{currentDoc?.name}</span>
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="p-0">
//           <div className="model-preview-container">
//             {currentDoc?.type === "application/pdf" ? (
//               <iframe
//                 title="PDF Viewer"
//                 src={currentDoc?.src}
//                 width="100%"
//                 height="500px"
//                 style={{ border: 'none' }}
//               />
//             ) : (
//               <img
//                 className="model-preview-image w-100"
//                 src={currentDoc?.src}
//                 alt={currentDoc?.name}
//                 style={{ maxHeight: '500px', objectFit: 'contain' }}
//               />
//             )}
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <button className="btn btn-success" onClick={handleDownload}>
//             <IoDownload className="me-2" />
//             Download
//           </button>
//           <button className="btn btn-secondary" onClick={handleCloseFileView}>
//             Close
//           </button>
//         </Modal.Footer>
//       </Modal>

//       <style jsx>{`
//         .document-card:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 4px 8px rgba(0,0,0,0.1);
//           transition: all 0.3s ease;
//         }
        
//         .document-name {
//           word-break: break-word;
//         }
        
//         .model-preview-container {
//           background: #f8f9fa;
//           min-height: 500px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//         }
        
//         .model-preview-image {
//           max-width: 100%;
//           height: auto;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default CompanyView;







import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Card, Row, Col, Modal, Badge } from "react-bootstrap";
import Swal from "sweetalert2";
import { BASE_URL } from "../../services/Api";
import { authHeader } from "../../services/auth-header";
import {
  IoBusiness,
  IoPerson,
  IoCall,
  IoMail,
  IoDocumentText,
  IoLocation,
  IoCalendar,
  IoDownload,
  IoEye,
  IoCreate
} from "react-icons/io5";
import { FaFilePdf, FaFileImage, FaUniversity } from "react-icons/fa";

const CompanyView = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [companyData, setCompanyData] = useState(null);
  const [fetchedImages, setFetchedImages] = useState([]);
  const [showModel, setShowModel] = useState(false);
  const [currentDoc, setCurrentDoc] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${BASE_URL}company/findById/${1}`, {
          headers: authHeader(),
        });

        const Data = response.data;
        setCompanyData(Data);

        // Fetch images
        if (Data.companyImages && Data.companyImages.length > 0) {
          const imagePromises = Data.companyImages.map(async (i) => {
            try {
              const response = await axios.get(
                BASE_URL + `companyImages/findById/${i.id}`,
                {
                  headers: authHeader(),
                  responseType: "blob",
                }
              );
              const contentType = response.headers["content-type"];
              const blob = new Blob([response.data], { type: contentType });
              const fileUrl = URL.createObjectURL(blob);
              return {
                src: fileUrl,
                name: i.filename,
                type: i.contenttype,
                id: i.id
              };
            } catch (error) {
              console.log("error in image fetch", error);
              return null;
            }
          });

          const imageUrls = await Promise.all(imagePromises);
          setFetchedImages(imageUrls.filter(img => img !== null));
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to fetch company details. Please try again.",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyData();
  }, [id]);

  const handleCurrentFileView = (doc) => {
    setCurrentDoc(doc);
    setShowModel(true);
  };

  const handleCloseFileView = () => {
    setCurrentDoc(null);
    setShowModel(false);
  };

  const handleDownload = () => {
    if (currentDoc) {
      const link = document.createElement("a");
      link.href = currentDoc.src;
      link.download = currentDoc.name;
      link.click();
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const getFileIcon = (fileType) => {
    if (fileType === "application/pdf") {
      return <FaFilePdf className="text-danger" size={20} />;
    }
    return <FaFileImage className="text-primary" size={20} />;
  };

  if (loading) {
    return (
      <div className="company-loading-container">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="company-loading-text">Loading company details...</p>
        </div>
      </div>
    );
  }

  if (!companyData) {
    return (
      <div className="company-empty-container">
        <div className="company-empty-card">
          <IoBusiness size={48} className="company-empty-icon" />
          <h6 className="company-empty-title">No company data found</h6>
          <p className="company-empty-text">Please add company details to get started</p>
          <Link to="/company/edit" className="company-add-button">
            <IoCreate size={14} />
            <span>Add Company Details</span>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <>
      <style>
        {`
          /* Company View Styles */
          .company-container {
            padding: 20px;
            background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);
            min-height: 100vh;
          }

          /* Header Styles */
          .company-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
            flex-wrap: wrap;
            gap: 12px;
          }

          .company-header-left {
            display: flex;
            align-items: center;
            gap: 12px;
          }

          .company-header-icon {
            width: 48px;
            height: 48px;
            background: white;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 2px 8px rgba(13, 148, 136, 0.1);
          }

          .company-header-title {
            font-size: 20px;
            font-weight: 600;
            color: #0f766e;
            margin: 0 0 2px 0;
          }

          .company-header-subtitle {
            font-size: 12px;
            color: #64748b;
            margin: 0;
          }

          .company-edit-button {
            display: flex;
            align-items: center;
            gap: 6px;
            padding: 6px 16px;
            background: linear-gradient(135deg, #14b8a6, #0d9488);
            border: none;
            border-radius: 8px;
            color: white;
            font-size: 12px;
            font-weight: 500;
            text-decoration: none;
            transition: all 0.2s ease;
          }

          .company-edit-button:hover {
            transform: translateY(-1px);
            box-shadow: 0 2px 8px rgba(13, 148, 136, 0.2);
            color: white;
          }

          /* Stats Grid */
          .company-stats-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
            gap: 12px;
            margin-bottom: 20px;
          }

          .company-stat-card {
            background: white;
            border-radius: 12px;
            padding: 16px;
            display: flex;
            align-items: center;
            gap: 12px;
            box-shadow: 0 1px 3px rgba(0,0,0,0.05);
            border: 1px solid #ccfbf1;
          }

          .company-stat-icon {
            width: 40px;
            height: 40px;
            background: #f0fdfa;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #14b8a6;
          }

          .company-stat-label {
            font-size: 11px;
            color: #64748b;
            font-weight: 500;
          }

          .company-stat-value {
            font-size: 20px;
            font-weight: 700;
            color: #0f766e;
          }

          /* Cards Grid */
          .company-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
            gap: 16px;
            margin-bottom: 20px;
          }

          .company-card {
            background: white;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 1px 3px rgba(0,0,0,0.05);
            border: 1px solid #ccfbf1;
          }

          .company-card-header-primary {
            background: linear-gradient(135deg, #14b8a6, #0d9488);
            padding: 12px 16px;
            display: flex;
            align-items: center;
            gap: 8px;
            color: white;
          }

          .company-card-header-success {
            background: linear-gradient(135deg, #10b981, #059669);
            padding: 12px 16px;
            display: flex;
            align-items: center;
            gap: 8px;
            color: white;
          }

          .company-card-header-warning {
            background: linear-gradient(135deg, #f59e0b, #d97706);
            padding: 12px 16px;
            display: flex;
            align-items: center;
            gap: 8px;
            color: white;
          }

          .company-card-header-info {
            background: linear-gradient(135deg, #3b82f6, #2563eb);
            padding: 12px 16px;
            display: flex;
            align-items: center;
            gap: 8px;
            color: white;
          }

          .company-card-title {
            margin: 0;
            font-size: 13px;
            font-weight: 600;
          }

          .company-card-body {
            padding: 16px;
          }

          /* Info Styles */
          .company-info-row {
            margin-bottom: 12px;
          }

          .company-info-label {
            font-size: 10px;
            color: #64748b;
            margin-bottom: 2px;
            text-transform: uppercase;
            letter-spacing: 0.3px;
          }

          .company-info-value {
            font-size: 14px;
            font-weight: 600;
            color: #1e293b;
          }

          .company-info-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 12px;
            margin-top: 8px;
          }

          .company-info-label-small {
            font-size: 10px;
            color: #94a3b8;
            margin-bottom: 2px;
            display: flex;
            align-items: center;
            gap: 4px;
          }

          .company-info-value-small {
            font-size: 12px;
            font-weight: 500;
            color: #334155;
          }

          .company-badge-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 12px;
          }

          .company-badge {
            font-size: 11px;
            padding: 3px 10px;
            font-weight: 500;
          }

          .company-badge-warning {
            font-size: 11px;
            padding: 3px 10px;
            font-weight: 500;
            background: #fef3c7;
            color: #d97706;
          }

          .company-expired-badge {
            margin-top: 10px;
          }

          /* Section Card */
          .company-section-card {
            background: white;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 1px 3px rgba(0,0,0,0.05);
            border: 1px solid #ccfbf1;
            margin-bottom: 20px;
          }

          .company-section-header {
            background: linear-gradient(135deg, #64748b, #475569);
            padding: 12px 16px;
            display: flex;
            align-items: center;
            gap: 8px;
            color: white;
          }

          .company-section-header-dark {
            background: linear-gradient(135deg, #1e293b, #0f172a);
            padding: 12px 16px;
            display: flex;
            align-items: center;
            gap: 8px;
            color: white;
          }

          .company-section-title {
            margin: 0;
            font-size: 13px;
            font-weight: 600;
          }

          /* Addresses */
          .company-addresses-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
            gap: 12px;
            padding: 16px;
          }

          .company-address-card {
            border: 1px solid #e2e8f0;
            border-radius: 10px;
            overflow: hidden;
            transition: all 0.2s ease;
          }

          .company-address-card:hover {
            transform: translateY(-1px);
            box-shadow: 0 2px 8px rgba(0,0,0,0.05);
            border-color: #ccfbf1;
          }

          .company-address-header {
            background: #f8fafc;
            padding: 10px 12px;
            border-bottom: 1px solid #e2e8f0;
          }

          .company-address-number {
            font-weight: 600;
            color: #0f766e;
            font-size: 12px;
          }

          .company-address-body {
            padding: 12px;
          }

          .company-address-text {
            font-size: 12px;
            color: #334155;
            margin-bottom: 10px;
            line-height: 1.4;
          }

          .company-address-details {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
            font-size: 11px;
            color: #64748b;
            margin-bottom: 10px;
          }

          .company-state-code-badge {
            font-size: 10px;
            padding: 2px 6px;
          }

          .company-empty-address {
            text-align: center;
            padding: 30px;
            color: #94a3b8;
          }

          /* Documents */
          .company-documents-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
            gap: 12px;
            padding: 16px;
          }

          .company-document-card {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 10px;
            border: 1px solid #e2e8f0;
            border-radius: 10px;
            cursor: pointer;
            transition: all 0.2s ease;
          }

          .company-document-card:hover {
            transform: translateY(-1px);
            box-shadow: 0 2px 8px rgba(13, 148, 136, 0.1);
          }

          .company-document-icon {
            width: 40px;
            height: 40px;
            background: #f1f5f9;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .company-document-info {
            flex: 1;
          }

          .company-document-name {
            font-size: 11px;
            font-weight: 500;
            color: #1e293b;
            margin-bottom: 4px;
          }

          .company-document-actions {
            display: flex;
            gap: 6px;
          }

          .company-document-action-btn {
            background: none;
            border: none;
            padding: 3px;
            cursor: pointer;
            color: #94a3b8;
            border-radius: 4px;
            transition: all 0.2s ease;
          }

          .company-document-action-btn:hover {
            background: #e2e8f0;
            color: #0f766e;
          }

          /* Loading & Empty States */
          .company-loading-container {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 50vh;
          }

          .company-loading-text {
            margin-top: 12px;
            font-size: 12px;
            color: #64748b;
          }

          .company-empty-container {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 50vh;
          }

          .company-empty-card {
            text-align: center;
            padding: 30px;
            background: white;
            border-radius: 12px;
            box-shadow: 0 1px 3px rgba(0,0,0,0.05);
          }

          .company-empty-icon {
            color: #cbd5e1;
            margin-bottom: 12px;
          }

          .company-empty-title {
            font-size: 14px;
            color: #475569;
            margin-bottom: 6px;
          }

          .company-empty-text {
            font-size: 12px;
            color: #94a3b8;
            margin-bottom: 16px;
          }

          .company-add-button {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            padding: 8px 20px;
            background: linear-gradient(135deg, #14b8a6, #0d9488);
            border: none;
            border-radius: 8px;
            color: white;
            font-size: 12px;
            text-decoration: none;
            font-weight: 500;
          }

          .company-add-button:hover {
            color: white;
          }

          /* Modal Styles */
          .company-modal-header {
            background: linear-gradient(135deg, #1e293b, #0f172a);
            color: white;
            border: none;
            padding: 12px 16px;
          }

          .company-modal-title {
            display: flex;
            align-items: center;
            font-size: 14px;
          }

          .company-modal-body {
            padding: 0;
            background: #f8fafc;
          }

          .company-preview-container {
            background: #f8f9fa;
            min-height: 500px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .company-preview-image {
            max-width: 100%;
            max-height: 500px;
            object-fit: contain;
          }

          .company-modal-footer {
            border-top: 1px solid #e2e8f0;
            padding: 12px 16px;
          }

          .company-download-btn {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            padding: 6px 16px;
            background: #10b981;
            border: none;
            border-radius: 6px;
            color: white;
            font-size: 12px;
            font-weight: 500;
            cursor: pointer;
          }

          .company-close-btn {
            padding: 6px 16px;
            background: #e2e8f0;
            border: none;
            border-radius: 6px;
            color: #475569;
            font-size: 12px;
            font-weight: 500;
            cursor: pointer;
          }
        `}
      </style>

      <div className="company-container">
        {/* Header Section */}
        <div className="company-header">
          <div className="company-header-left">
            <div className="company-header-icon">
              <IoBusiness size={24} style={{ color: '#0d9488' }} />
            </div>
            <div>
              <h2 className="company-header-title">Company Details</h2>
              <p className="company-header-subtitle">View and manage company information</p>
            </div>
          </div>
          <Link to="/company/edit" className="company-edit-button">
            <IoCreate size={14} />
            <span>Edit Details</span>
          </Link>
        </div>

        {/* Stats Cards */}
        <div className="company-stats-grid">
          <div className="company-stat-card">
            <div className="company-stat-icon"><IoDocumentText size={20} /></div>
            <div>
              <div className="company-stat-label">Documents</div>
              <div className="company-stat-value">{fetchedImages.length}</div>
            </div>
          </div>
          <div className="company-stat-card">
            <div className="company-stat-icon"><IoLocation size={20} /></div>
            <div>
              <div className="company-stat-label">Addresses</div>
              <div className="company-stat-value">{companyData.companyMultipleAddresses?.length || 0}</div>
            </div>
          </div>
          <div className="company-stat-card">
            <div className="company-stat-icon"><FaUniversity size={20} /></div>
            <div>
              <div className="company-stat-label">Bank Accounts</div>
              <div className="company-stat-value">1</div>
            </div>
          </div>
        </div>

        {/* Main Content Grid */}
        <div className="company-grid">
          {/* Basic Information Card */}
          <div className="company-card">
            <div className="company-card-header-primary">
              <IoBusiness size={16} />
              <h6 className="company-card-title">Basic Information</h6>
            </div>
            <div className="company-card-body">
              <div className="company-info-row">
                <div className="company-info-label">Company Name</div>
                <div className="company-info-value">{companyData.companyname || "N/A"}</div>
              </div>
              <div className="company-info-grid">
                <div>
                  <div className="company-info-label-small">
                    <IoPerson size={12} /> Contact Person
                  </div>
                  <div className="company-info-value-small">{companyData.contactperson || "N/A"}</div>
                </div>
                <div>
                  <div className="company-info-label-small">
                    <IoMail size={12} /> Email
                  </div>
                  <div className="company-info-value-small">{companyData.email || "N/A"}</div>
                </div>
                <div>
                  <div className="company-info-label-small">
                    <IoCall size={12} /> Work Contact
                  </div>
                  <div className="company-info-value-small">{companyData.workcontactno || "N/A"}</div>
                </div>
                <div>
                  <div className="company-info-label-small">
                    <IoCall size={12} /> Office Contact
                  </div>
                  <div className="company-info-value-small">{companyData.officecontactno || "N/A"}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Legal & Registration Card */}
          <div className="company-card">
            <div className="company-card-header-success">
              <IoDocumentText size={16} />
              <h6 className="company-card-title">Legal & Registration</h6>
            </div>
            <div className="company-card-body">
              <div className="company-badge-grid">
                <div>
                  <div className="company-info-label-small">PAN Number</div>
                  <Badge bg="primary" className="company-badge">{companyData.panno || "N/A"}</Badge>
                </div>
                <div>
                  <div className="company-info-label-small">GST Number</div>
                  <Badge bg="success" className="company-badge">{companyData.gstno || "N/A"}</Badge>
                </div>
                <div>
                  <div className="company-info-label-small">CIN Number</div>
                  <div className="company-info-value-small">{companyData.cinno || "N/A"}</div>
                </div>
                <div>
                  <div className="company-info-label-small">LUT Number</div>
                  <div className="company-info-value-small">{companyData.lutno || "N/A"}</div>
                </div>
                <div>
                  <div className="company-info-label-small">Udyam Registration</div>
                  <div className="company-info-value-small">{companyData.udyamregistrationno || "N/A"}</div>
                </div>
                <div>
                  <div className="company-info-label-small">IEC Number</div>
                  <div className="company-info-value-small">{companyData.iecno || "N/A"}</div>
                </div>
                <div>
                  <div className="company-info-label-small">
                    <IoCalendar size={10} /> Incorporation Date
                  </div>
                  <div className="company-info-value-small">{formatDate(companyData.incorporationdate)}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Bank Details Card */}
          <div className="company-card">
            <div className="company-card-header-warning">
              <FaUniversity size={16} />
              <h6 className="company-card-title">Bank Details</h6>
            </div>
            <div className="company-card-body">
              <div className="company-info-row">
                <div className="company-info-label">Bank Name</div>
                <div className="company-info-value">{companyData.bankname || "N/A"}</div>
              </div>
              <div className="company-info-grid">
                <div>
                  <div className="company-info-label-small">Account Number</div>
                  <div className="company-info-value-small">{companyData.accountnumber || "N/A"}</div>
                </div>
                <div>
                  <div className="company-info-label-small">Branch Name</div>
                  <div className="company-info-value-small">{companyData.branchname || "N/A"}</div>
                </div>
                <div>
                  <div className="company-info-label-small">IFSC Code</div>
                  <Badge bg="warning" className="company-badge-warning">{companyData.ifsccode || "N/A"}</Badge>
                </div>
              </div>
            </div>
          </div>

          {/* Insurance Details Card */}
          <div className="company-card">
            <div className="company-card-header-info">
              <IoDocumentText size={16} />
              <h6 className="company-card-title">Insurance Details</h6>
            </div>
            <div className="company-card-body">
              <div className="company-info-row">
                <div className="company-info-label">Policy Number</div>
                <div className="company-info-value">{companyData.policynumber || "N/A"}</div>
              </div>
              <div className="company-info-row">
                <div className="company-info-label-small">
                  <IoCalendar size={10} /> Valid Till
                </div>
                <div className="company-info-value-small">{formatDate(companyData.policyvalidtill)}</div>
              </div>
              {companyData.policyvalidtill && new Date(companyData.policyvalidtill) < new Date() && (
                <div className="company-expired-badge">
                  <Badge bg="danger">Policy Expired</Badge>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Addresses Section */}
        <div className="company-section-card">
          <div className="company-section-header">
            <IoLocation size={16} />
            <h6 className="company-section-title">Company Addresses</h6>
          </div>
          <div className="company-addresses-grid">
            {companyData.companyMultipleAddresses && companyData.companyMultipleAddresses.length > 0 ? (
              companyData.companyMultipleAddresses.map((addr, index) => (
                <div key={index} className="company-address-card">
                  <div className="company-address-header">
                    <span className="company-address-number">Address {index + 1}</span>
                  </div>
                  <div className="company-address-body">
                    <p className="company-address-text">{addr.address || "N/A"}</p>
                    <div className="company-address-details">
                      <span><strong>City:</strong> {addr.city?.cityname || "N/A"}</span>
                      <span><strong>State:</strong> {addr.state?.statename || "N/A"}</span>
                      <span><strong>Country:</strong> {addr.country?.countryname || "N/A"}</span>
                      <span><strong>Zip:</strong> {addr.zipcode || "N/A"}</span>
                    </div>
                    <Badge bg="secondary" className="company-state-code-badge">
                      State Code: {addr.statecode || "N/A"}
                    </Badge>
                  </div>
                </div>
              ))
            ) : (
              <div className="company-empty-address">
                <IoLocation size={40} style={{ color: '#cbd5e1' }} />
                <p>No addresses found</p>
              </div>
            )}
          </div>
        </div>

        {/* Documents Section */}
        {fetchedImages.length > 0 && (
          <div className="company-section-card">
            <div className="company-section-header-dark">
              <IoDocumentText size={16} />
              <h6 className="company-section-title">Company Documents</h6>
            </div>
            <div className="company-documents-grid">
              {fetchedImages.map((doc, index) => (
                <div
                  key={index}
                  className="company-document-card"
                  onClick={() => handleCurrentFileView(doc)}
                >
                  <div className="company-document-icon">
                    {getFileIcon(doc.type)}
                  </div>
                  <div className="company-document-info">
                    <div className="company-document-name">
                      {doc.name.length > 25 ? doc.name.substring(0, 25) + '...' : doc.name}
                    </div>
                    <div className="company-document-actions">
                      <button
                        className="company-document-action-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCurrentFileView(doc);
                        }}
                        title="View"
                      >
                        <IoEye size={14} />
                      </button>
                      <button
                        className="company-document-action-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          const link = document.createElement("a");
                          link.href = doc.src;
                          link.download = doc.name;
                          link.click();
                        }}
                        title="Download"
                      >
                        <IoDownload size={14} />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Document Preview Modal */}
        <Modal show={showModel} onHide={handleCloseFileView} size="lg" centered>
          <Modal.Header closeButton className="company-modal-header">
            <Modal.Title className="company-modal-title">
              {getFileIcon(currentDoc?.type)}
              <span style={{ marginLeft: '8px', fontSize: '14px' }}>{currentDoc?.name}</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="company-modal-body">
            <div className="company-preview-container">
              {currentDoc?.type === "application/pdf" ? (
                <iframe
                  title="PDF Viewer"
                  src={currentDoc?.src}
                  width="100%"
                  height="500px"
                  style={{ border: 'none' }}
                />
              ) : (
                <img
                  className="company-preview-image"
                  src={currentDoc?.src}
                  alt={currentDoc?.name}
                />
              )}
            </div>
          </Modal.Body>
          <Modal.Footer className="company-modal-footer">
            <button className="company-download-btn" onClick={handleDownload}>
              <IoDownload size={14} />
              <span>Download</span>
            </button>
            <button className="company-close-btn" onClick={handleCloseFileView}>
              Close
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default CompanyView;